import React, { Children } from "react";
import ReactModal from "react-modal";
import { colour, spacing } from '../../theme';

interface Props {
  modalIsOpen: boolean;
  shouldCloseOnOverlayClick: boolean;
  children: React.ReactNode;
  onRequestClose;
  fileViewer?: boolean;
}

interface State {


}
export class ModalComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

  }


  render() {
    const gap = this.props.fileViewer? '20%': '50%';
    const trans = this.props.fileViewer? 'translate(-10%, -10%)': 'translate(-50%, -50%)';

    return (<>
     {/* @ts-ignore */}
     <ReactModal
          style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
              background: colour.palette.white,
              overflow: "auto",
              padding: `${spacing.spacing5} ${spacing.spacing4}`,
              boxShadow: "rgba(26, 26, 26, 0.6) 0 0 2px",
              transition: "box-shadow 0.1s ease-in-out 0s"
          },
          overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.7)"} }}
          isOpen={this.props.modalIsOpen}
          shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
          onRequestClose={this.props.onRequestClose}
        >
        <>{this.props.children}</>
        </ReactModal>
    </>
       
    );

  }

}